/* eslint-disable prettier/prettier */
import React from "react";

const TotalProjectIcon = ({ onClickHandle }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3578_2)">
      <rect x="4" y="4" width="16" height="16" rx="2" fill="#DAF3FF" />
    </g>
    <path
      d="M14.7188 9.1875H13.7812C13.7297 9.1875 13.6875 9.22969 13.6875 9.28125V14.7188C13.6875 14.7703 13.7297 14.8125 13.7812 14.8125H14.7188C14.7703 14.8125 14.8125 14.7703 14.8125 14.7188V9.28125C14.8125 9.22969 14.7703 9.1875 14.7188 9.1875ZM12.4688 12.4688H11.5312C11.4797 12.4688 11.4375 12.5109 11.4375 12.5625V14.7188C11.4375 14.7703 11.4797 14.8125 11.5312 14.8125H12.4688C12.5203 14.8125 12.5625 14.7703 12.5625 14.7188V12.5625C12.5625 12.5109 12.5203 12.4688 12.4688 12.4688ZM10.2188 11.625H9.28125C9.22969 11.625 9.1875 11.6672 9.1875 11.7188V14.7188C9.1875 14.7703 9.22969 14.8125 9.28125 14.8125H10.2188C10.2703 14.8125 10.3125 14.7703 10.3125 14.7188V11.7188C10.3125 11.6672 10.2703 11.625 10.2188 11.625ZM7.6875 16.6875H16.3125C16.5199 16.6875 16.6875 16.5199 16.6875 16.3125V7.6875C16.6875 7.48008 16.5199 7.3125 16.3125 7.3125L7.6875 7.3125C7.48008 7.3125 7.3125 7.48008 7.3125 7.6875L7.3125 16.3125C7.3125 16.5199 7.48008 16.6875 7.6875 16.6875ZM8.15625 8.15625L15.8438 8.15625L15.8438 15.8438L8.15625 15.8437L8.15625 8.15625Z"
      fill="#0094D9"
    />
    <defs>
      <filter
        id="filter0_d_3578_2"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3578_2"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3578_2"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default TotalProjectIcon;
